/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { passwordEdit, passwordUpdate } from 'store/modules/profile_store/actions';
import { ProfileState } from 'store/modules/profile_store/types';
import Loader from 'components/atoms/loader';

const PasswordEdit = () => {
  const dispatch = useDispatch();
  const [passwordNew, setPasswordNew] = useState<string>('');
  const [passwordConfirm, setPasswordConfirm] = useState<string>('');
  const [formSubmitted, setFormSubmitted] = useState<boolean>(false);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);
  const reset_password_token = React.useMemo(() => {
    return new URLSearchParams(window.location.search).get('reset_password_token');
  }, []);

  const { profile, password_edit, password_update } = useSelector<ApplicationState, ProfileState>(
    (state) => state.storage.profile,
  );

  const hasFetched = useRef(false);

  useEffect(() => {
    if (hasFetched.current) return;

    if (!reset_password_token) return;

    hasFetched.current = true;

    dispatch(passwordEdit(reset_password_token));
  }, [dispatch, reset_password_token]);

  const handlePasswordUpdate = () => {
    setFormSubmitted(true);

    if (passwordNew === passwordConfirm) {
      if (passwordNew.length >= 8 && /^(?=.*[a-zA-Z])(?=.*\d).+$/.test(passwordNew)) {
        dispatch(passwordUpdate(passwordNew, passwordConfirm, reset_password_token));
      }
    }
  };

  useEffect(() => {
    if (profile?.message_success_password === 'Sua senha foi redefinida.') {
      setButtonDisabled(true);
      setTimeout(() => {
        window.location.href = '/';
      }, 3000);
    }
  }, [profile?.message_success_password]);

  return (
    <div className="row">
      <div className="col-md-12 text-center">
        {password_update?.loaded && profile?.message_success_password !== '' && (
          <div className="alert alert-success" role="alert">
            {profile?.message_success_password}
          </div>
        )}
        <h4 className="font-weight-bold">Redefinição de senha</h4>

        {password_edit?.loading ? (
          <Loader />
        ) : (
          <div className="row justify-content-center">
            <div className="col-md-4">
              <div className="card mt-1 p-5">
                <div className="card-body">
                  <div className="text-left">
                    <label htmlFor="email">Email</label>
                    <input
                      type="text"
                      className="form-control mt-1"
                      disabled
                      id="email"
                      value={profile?.resource_email}
                    />
                    <div className="alert alert-info mt-3" role="alert">
                      A senha deve ter no mínimo 8 caracteres, incluindo pelo menos uma letra e um
                      número.
                    </div>
                    <label htmlFor="email" className="mt-1">
                      * Nova senha
                    </label>
                    <input
                      type="password"
                      className="form-control mt-1"
                      id="password-new"
                      value={passwordNew}
                      onChange={(e) => setPasswordNew(e.target.value)}
                    />
                    {passwordNew.length > 0 && passwordNew.length < 8 && (
                      <p className="text-danger">Senha deve ter no mínimo 8 caracteres.</p>
                    )}
                    {passwordNew.length >= 8 && !/(?=.*[a-zA-Z])(?=.*\d).+$/.test(passwordNew) && (
                      <p className="text-danger">
                        Senha deve conter pelo menos uma letra e um número.
                      </p>
                    )}
                    <label htmlFor="email" className="mt-1">
                      * Confirme a nova senha
                    </label>
                    <input
                      type="password"
                      className="form-control mt-1"
                      id="password-confirm"
                      value={passwordConfirm}
                      onChange={(e) => setPasswordConfirm(e.target.value)}
                    />
                    {passwordNew !== passwordConfirm && formSubmitted && (
                      <p className="text-danger">As senhas não são iguais</p>
                    )}
                    <button
                      type="button"
                      className="btn btn-primary btn-lg btn-block my-3"
                      onClick={() => handlePasswordUpdate()}
                      disabled={buttonDisabled || !passwordNew || !passwordConfirm}
                    >
                      Redefinir senha
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PasswordEdit;
